<template>
	<div class="brick view_brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text mgr_15">
					Location
				</em>
				<span class="int_type mgr_15">
					<select v-model="location_code" class="tbl_select sm_int" @change="selectLocation()">
						<option v-for="location in locations" v-bind:value="location.code" v-bind:key="location.code">{{ location.name }}</option>
					</select>
				</span>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_big2_tbl" style="height:780px;">
				<div class="fixed-table-container">
					<div class="table-wrapper" ref="table_wrapper">
						<table id="item_list" class="list_tbl tbl_pointer">
							<thead>
								<tr>
									<th style="text-align:center;width:80px;"><div class="th-text">Rack</div></th>
									<th style="text-align:center;width:80px;"><div class="th-text">Section</div></th>
									<th style="text-align:center;width:60px;"><div class="th-text">Order</div></th>
									<th style="text-align:center;width:60px;"><div class="th-text">Input</div></th>
									<!-- <th style="text-align:center;width:100px;"><div class="th-text">Current Order</div></th>									
									<th style="text-align:center;width:100px;"><div class="th-text">New Order</div></th> -->
									<th style="text-align:center;width:60px;"><div class="th-text">Up</div></th>
									<th style="text-align:center;width:80px;"><div class="th-text">Down</div></th>
									<th style="text-align:center;"><div class="th-text">Item(s)</div></th>
								</tr>
							</thead>

							<tbody>
								<!-- <tr v-for="(p, index) in pick_orders" v-bind:key="index" v-bind:class="{ on: p.section == selectedPickOrder.section && p.rack == selectedPickOrder.rack }" @click="selectRow(p)"> -->
								<tr v-for="(p, index) in pick_orders" v-bind:key="index" v-bind:class="{ on: selected_index == index }" @click="selectRow(index)">
									<!-- <tr v-for="(p, index) in pick_orders" v-bind:key="index"> -->
									<td>{{ p.rack }}</td>
									<td>{{ p.section }}</td>
									<td style="text-align:right;"><currency-input type="text" :ref="index + '_ord_inp'" v-model.trim="p.idx" :precision="0" @focus="$event.target.select()" class="tbl_int al_right" /></td>
									<td style="text-align:center;" @click.stop=""><a href="javascript:;" class="gray_bt2" style="width:50px;" @click="inputIdx(index)">Inp.</a></td>
									<!-- <td style="text-align:right;">{{ p.order_no }}</td>									
									<td style="text-align:right;">{{ p.new_order_no }}</td> -->
									<td style="text-align:center;" @click.stop=""><a v-if="index != 0" href="javascript:;" class="gray_bt2" style="width:50px;" @click="up(index)">Up</a></td>
									<td style="text-align:center;" @click.stop=""><a v-if="index + 1 != pick_orders.length" href="javascript:;" class="gray_bt2" style="width:70px;" @click="down(index)">Down</a></td>
									<td class="truncate">{{ p.item_codes }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div style="text-align:right;padding-top:5px; padding-right:10px;">Total Count : {{ pick_orders.length | commaSeparated }}</div>

				<div class="view_bottom_bt">
					<a href="javascript:;" class="gray_bt" @click="save()">Save Picking Order</a>
				</div>
			</div>

			<div class="right_small2_tbl">
				<h4 class="inner_h5">Details</h4>
				<!-- <a href="javascript:;" class="gray_bt2" @click="down()">Down</a> -->
				<!-- <table class="view_tbl" border="0">
					<colgroup>
						<col style="width:100px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>Code</th>
							<td>
								<input type="text" v-model.trim="code.code" maxlength="30" ref="code" class="tbl_int sm_int" v-bind:disabled="mode == 'detail'" />
								<button v-if="mode == 'add'" v-bind:disabled="!code.code" class="gray_bt" @click="checkDup()">Check Dup.</button>
								<span v-if="mode == 'detail'">
									<span v-if="code.crt_dt">Created: {{ code.crt_dt | moment('MM-DD-YYYY') }} {{ code.crt_user }}</span
									><span v-if="code.upd_dt">, Updated: {{ code.upd_dt | moment('MM-DD-YYYY') }} {{ code.upd_user }}</span></span
								>
							</td>
						</tr>

						<tr>
							<th>Name</th>
							<td><input type="text" v-model.trim="code.name" class="tbl_int full_int" /></td>
						</tr>
						<tr>
							<th>{{ code_type == 'PT' ? 'Due Days' : 'Description' }}</th>
							<td><input type="text" v-model.trim="code.description" class="tbl_int full_int" :placeholder="code_type == 'PT' ? 'Due Days' : 'Description'" /></td>
						</tr>
						<tr>
							<th>Alternative Code</th>
							<td><input type="text" v-model.trim="code.alt_code" class="tbl_int sm_int" /></td>
						</tr>
						<tr>
							<th>Remark</th>
							<td><input type="text" v-model.trim="code.remark" class="tbl_int sm_int" /></td>
						</tr>
						<tr>
							<th>{{ code_type == 'WL' ? 'Pick ' : '' }}Order No</th>
							<td><input type="number" v-model.trim="code.order_no" class="tbl_int sm_int" /></td>
						</tr>
						<tr>
							<th>
								<img v-img v-if="code.image_file_name" :src="getImageUrl(code)" alt="File Not Found" style="cursor: zoom-in;max-height:70px;max-width:70px;height:auto;width:auto;" />
								<span v-if="!code.image_file_name">Picture</span>
							</th>
							<td>
								<button v-if="modifiable" :disabled="mode == 'add' || !code.code" class="btn" @click="uploadFile()">{{ !code.image_file_name ? 'Upload' : 'Replace' }} File</button>
								<input v-show="false" type="file" ref="uploadFile" class="file_input_hidden" accept="image/*" @change="uploadFileConfirm()" />
								&nbsp;
								<button v-if="modifiable" :disabled="!code.image_file_name" class="btn" style="margin-top:10px;" @click="clear()">Clear Picture</button>
							</td>
						</tr>
						<tr>
							<th></th>
							<td>
								<label for="active_yn" style="margin-left:5px;"> <input type="checkbox" id="active_yn" v-model="code.active_yn" true-value="Y" false-value="N" />Active</label>
							</td>
						</tr>
						<CodeOtherBool :code="code" :code_type="code_type" />
					</tbody>
				</table> -->

				<!-- <div v-if="modifiable" class="view_bottom_bt" style="padding-top:15px;">
					<a v-if="!user.image_mgmt_only && code_type === 'COL'" href="javascript:void(0);" class="gray_bt mgr_5" @click="updateAllWhColorCode()">All Update Color 2nd Code</a>
					<a v-if="!user.image_mgmt_only" href="javascript:;" :class="!isValid ? 'disable_bt' : 'search_bt'" @click="submit()">Save</a>
					<a v-if="!user.image_mgmt_only" href="javascript:;" :class="!isDeletable ? 'disable_bt' : 'gray_bt'" @click="del()" class="delete_button">Delete</a>
				</div> -->
			</div>
		</div>

		<!-- <div class="view_inner">
			<table vclass="view_tbl">
				<colgroup>
					<col style="width:180px;" />
					<col style="width:120px;" />
				</colgroup>
				<tbody>
					<tr>
						<th>Android Version</th>
						<td>
							<input type="text" v-model="and_version_code" class="tbl_int sm_int al_right" style="width:230px;" @focus="$event.target.select()" />
						</td>
					</tr>
					<tr>
						<th>iOS Version</th>
						<td>
							<input type="text" v-model="ios_version_code" class="tbl_int sm_int al_right" style="width:230px;" @focus="$event.target.select()" />
						</td>
					</tr>
				</tbody>
			</table>

			<div class="view_bottom_bt">
				<a href="javascript:;" @click="submit()" type="button" class="search_bt">Save</a>
			</div>
		</div> -->
	</div>
</template>

<script>
import { apiIndex, apiSelectPickOrderList, apiUpdatePickOrder } from '@/api/basicinfo/pick_order.js';
//import _ from 'lodash';

export default {
	data: function() {
		return {
			backUri: '/',

			locations: [],
			location_code: null,

			pick_orders: [],

			//selectedPickOrder: {},
			selected_index: null,
			tbl_key: 0,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		// pick_orders_sorted: function() {
		// 	return _.orderBy(this.pick_orders, ['new_order_no'], ['asc']);
		// },
	},
	components: {
		//ChangePassword,
		//GoogleMap,
		//Modal,
	},
	methods: {
		// up() {
		// 	if (this.selectedPickOrder && this.selectedPickOrder.new_order_no != 1) {
		// 		//const cur_row = this.selectedPickOrder.new_order_no - 1;
		// 		console.log('up');
		// 		this.selectedPickOrder.new_order_no--;
		// 		this.$forceUpdate();

		// 		//if this.selectedPickOrder.new
		// 	}
		// },
		async save() {
			var ord = 1;
			this.pick_orders.forEach(p => {
				p.order_no = ord++;
			});

			//console.log(this.pick_orders);
			const { data } = await apiUpdatePickOrder({
				location_code: this.location_code,
				order_list: this.pick_orders,
			});

			if (data.result) {
				this.$toast.success('Saved successfully');
				//await this.selectCodes();
			} else {
				this.$toast.error(data.msg);
			}
		},
		inputIdx(rowIndex) {
			let idx = this.pick_orders[rowIndex].idx;
			if (idx < 1) {
				this.$toast.error('Enter a Number Greater than 1.');
				this.pick_orders[rowIndex].idx = this.pick_orders[rowIndex].ori_idx;
				return;
			} else if (idx > this.pick_orders.length) {
				this.$toast.error('Enter a Number Less than ' + this.pick_orders.length);
				this.pick_orders[rowIndex].idx = this.pick_orders[rowIndex].ori_idx;
				return;
			}

			this.pick_orders.splice(idx - 1, 0, this.pick_orders.splice(rowIndex, 1)[0]);
			this.reorder(this.pick_orders);

			this.$nextTick(() => {
				const el = this.$refs[idx - 1 + '_ord_inp'][0].$el;
				const wrapper = this.$refs.table_wrapper;
				if (wrapper.scrollTop + wrapper.offsetHeight < el.offsetParent.offsetTop) wrapper.scrollTop = el.offsetParent.offsetTop;
				else if (el.offsetParent.offsetTop < wrapper.scrollTop) wrapper.scrollTop = el.offsetParent.offsetTop;

				el.select();
				this.selectRow(idx - 1);
			});
		},
		up(rowIndex) {
			this.pick_orders.splice(rowIndex - 1, 0, this.pick_orders.splice(rowIndex, 1)[0]);
			this.selectRow(rowIndex - 1);
		},
		down(rowIndex) {
			//console.log(rowIndex);
			//this.selectedPickOrder = this.pick_orders[rowIndex + 1];
			this.pick_orders.splice(rowIndex + 1, 0, this.pick_orders.splice(rowIndex, 1)[0]);
			//this.selected_index = rowIndex + 1;
			this.selectRow(rowIndex + 1);
			// console.log(this.selected_index);
			// this.$forceUpdate();
		},
		selectRow(index) {
			this.selected_index = index;
			//this.selectedPickOrder = p;
			//console.log(code);
		},
		reorder(pickOrderList) {
			if (!Array.isArray(pickOrderList)) return [];

			pickOrderList.forEach((el, index) => {
				el.idx = index + 1;
				el.ori_idx = index + 1;
			});

			return pickOrderList;
		},
		async selectLocation() {
			this.selectedPickOrder = {};

			if (this.location_code) {
				//console.log('code', this.location_code);
				const { data } = await apiSelectPickOrderList({ location_code: this.location_code });
				this.pick_orders = this.reorder(data.pickOrderList);
				//console.log(this.pick_orders);
			}
		},
		async init() {
			const { data } = await apiIndex();

			this.locations = data.locationList;
			if (this.locations.length > 0) {
				this.location_code = this.locations[0].code;

				await this.selectLocation();
			}
		},
	},
	created() {
		this.backUri = '/';
		//console.log(this.menus);
		//console.log(this.fav_menus);

		//this.$store.sideIndex = 9;
		this.$store.commit('setSideIndex', 9);
		this.$store.commit('setSelectedMenu', 'nav_li_pick_order');
		this.$store.commit('setSubTitle', 'Basic Information -> Pick Order');

		this.init();
	},
};
</script>

<style></style>
